// DO NOT ENABLE THIS VENDOR GLOBALLY
// We treat Google Analytics differently than our other vendors -- we do not want to
// initialize GA globally in the app but instead we should only initialize it on the
// page where it is needed (Facet Quiz)

window.dataLayer = window.dataLayer || [];
function gtag() {
  // eslint-disable-next-line prefer-rest-params,no-undef
  dataLayer.push(arguments);
}

const getTagID = () => process.env.REACT_APP_GOOGLE_TAG_ID;

export const initializeGoogleAnalytics = () => {
  if (getTagID) {
    gtag('js', new Date());

    // To verify the tag is configured to send the custom dimension you want to see this in your console when
    // debugging with Tag Assistant Chrome extension:
    // Processing GTAG command: ["config", "G-B1Q3NPYQGV", {is_facet_app: "true"}]
    gtag('config', getTagID(), {
      is_facet_app: 'true',
    });
  }
};

export const teardownGoogleAnalytics = () => {
  // eslint-disable-next-line no-func-assign
  gtag = undefined;
};
